export default __webpack_public_path__ + "static/media/Incipence.6c93267f.png";